import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { TypeContrat } from '../models/options/typeContrats/typeContrat'

const resource = 'TypeContrats'

export default class TypeContratsResource {
  public async paginatedList(pagenumber?: number, pagesize?: number) : Promise<PaginatedList<TypeContrat>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }

  public async post(data : TypeContrat) : Promise<TypeContrat> {
    const response = await api.post(`${resource}`, data)
    return response.data
  }

  public async delete(id : string) : Promise<TypeContrat> {
    const response = await api.delete(`${resource}/${id}`)
    return response.data
  }

  public async put(id : string, data : TypeContrat) : Promise<TypeContrat> {
    const response = await api.put(`${resource}/${id}`, data)
    return response.data
  }

  public downloadFile(): void {
    var url = 'https://localhost:57679/entreprises/13/ActionsCollectives/12'
    window.open(url, '_blank');
  }

  public async uploadFile(file: any, config: any): Promise<any> {
        
    let formData = new FormData();
    formData.append('files', file);
    formData.append('strings', "file");


    // config = {
    //   onUploadProgress: function(progressEvent: any) {
    //     var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    //     console.log(percentCompleted)
    //   }
    // }

    const response = await api.post(`entreprises/13/ActionsCollectives/12`, formData, {
      onUploadProgress: function(progressEvent: any) {
        var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        console.log(percentCompleted)
      }
    })
    return response.data
  }
}
